// this can be used by setting ID "#sticky-bar" to an element in elementor
jQuery(document).ready(function ($) {
  const stickyBarEl = $('#sticky-bar');
  const stickyBarVisibleEl = $('#sticky-bar-visible');
  if (!stickyBarEl.length && !stickyBarVisibleEl.length) {
    return;
  }
  // const isVisible = stickyBarVisibleEl.length;
  // const stickyBar = isVisible ? stickyBarVisibleEl : stickyBarEl;
  const stickyBar = stickyBarEl;
  const headerBar = isMobileView() ? $('#header-bar-mobile') : $('#header-bar');
  const topInfoBar = $('#header-info-bar');
  const hasTopInfoBar = topInfoBar.length > 0 && topInfoBar.css('display') !== 'none';

  let triggerPoint = 100;
  if (hasTopInfoBar) {
    triggerPoint = 128;
  }
  let lastScrollTop = 0;
  // if (!isVisible) {
  //   stickyBar.css('opacity', 0);
  // }

  $(window).on('scroll', function () {
    let currentScrollTop = $(this).scrollTop();
    if (currentScrollTop < lastScrollTop) {
      // Scrolling upwards
      if (stickyBar[0].getBoundingClientRect().top <= triggerPoint && (lastScrollTop - currentScrollTop > 5)) {
        showHeader();
        stickyBar.css('opacity', 1);

        let positionTop = isMobileView() ? (headerBar.height()) + 'px' : (headerBar.height()) + 'px'; //isMobileView() ? '62px' : '66px';
        if (hasTopInfoBar) {
          positionTop = (topInfoBar.height() + headerBar.height()) + 'px'; //isMobileView() ? '116px' : '94px';
        }
        stickyBar.css('top', positionTop);
      } else if (stickyBar[0].getBoundingClientRect().top > triggerPoint) {
        showHeader();
        // if (!isVisible) {
        //   stickyBar.css('opacity', 0);
        // }
      }
    } else {
      if (stickyBar[0].getBoundingClientRect().top <= triggerPoint) {
        // Scrolling downwards
        stickyBar.css('opacity', 1);
        let positionTop = hasTopInfoBar ? topInfoBar.height() : '0';
        stickyBar.css('top', positionTop);
        hideHeader();
      } else {
        // if (!isVisible) {
        //   stickyBar.css('opacity', 0);
        // }
      }
    }

    lastScrollTop = currentScrollTop;
  });

  function hideHeader() {
    headerBar.css('transform', 'translate(0, -100%)');
    // $('#header-bar-mobile').css('transform', 'translate(0, -100%)');
  }

  function showHeader() {
    headerBar.css('transform', 'none');
    // $('#header-bar-mobile').css('transform', 'none');

    if (hasTopInfoBar) {
      headerBar.css('top', topInfoBar.height())
    } else {
      headerBar.css('top', '0')
    }
  }

  function isMobileView() {
    return window.matchMedia('(max-width: 480px)').matches;
  }
});